var map = {
	"./point_1.png": "a60a",
	"./point_2.png": "9631",
	"./point_3.png": "7e77",
	"./point_4.png": "2ae4",
	"./point_5.png": "0289",
	"./point_6.png": "8a1b",
	"./point_act.png": "83b2",
	"./point_circle.png": "daf8",
	"./point_jjr.png": "fc61",
	"./point_qd_not.png": "2b79",
	"./point_qd_ssas.png": "2f51",
	"./point_zd.png": "fe34",
	"./point_zd_2.png": "2eb1",
	"./point_zd_3.png": "b2f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d414";